var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimOperazioni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.5 75.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.8px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,61.6l-9-.8v9.1M9.4,62.1c6.2,7.4,15.4,12.1,25.8,12.1s20.6-5.2,26.8-13.3M4.1,53.5c-1.8-4.1-2.7-8.7-2.7-13.5C1.4,23.1,13.6,9,29.6,6.3M39.2,6.1c16.8,2,29.8,16.4,29.8,33.9s-.8,8.2-2.1,11.9M23.5,1.4l7.7,4.7-5.2,7.4M74.1,49.1l-7.9,4.3-3.7-8.3M27,40.1c0-4.5,3.6-8.2,8.1-8.2s8.1,3.7,8.1,8.2-3.6,8.2-8.1,8.2-8.1-3.7-8.1-8.2ZM19.2,43.3l-4.7,3.5c.9,3,2.5,5.6,4.5,7.9l5.4-2.3c1.6,1.4,3.5,2.5,5.5,3.2l.7,5.9c1.5.3,3,.5,4.5.5s3.1-.2,4.5-.5l.7-5.9c2-.7,3.9-1.8,5.5-3.2l5.4,2.3c2-2.3,3.6-4.9,4.5-7.9l-4.7-3.5c.2-1,.3-2.1.3-3.2s-.1-2.2-.3-3.2l4.7-3.5c-.9-3-2.5-5.6-4.5-7.9l-5.4,2.3c-1.6-1.4-3.5-2.5-5.5-3.2l-.7-5.9c-1.5-.3-3-.5-4.5-.5s-3.1.2-4.5.5l-.7,5.9c-2,.7-3.9,1.8-5.5,3.2l-5.4-2.3c-2,2.3-3.6,4.9-4.5,7.9l4.7,3.5c-.2,1-.3,2.1-.3,3.2s.1,2.2.3,3.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimOperazioni);
export default __webpack_public_path__ + "static/media/dim-operazioni.b1a3404ded1682f2af67c84c1cb76d1e.svg";
export { ForwardRef as ReactComponent };